import { NavLink, useLocation } from "react-router-dom";
import SubRouter from "../../../router/subRouter";
import { CONFIGURATION_ROUTER_URL } from "../../../constants/routerUrl";
import { ISubMenu } from "../../../models/common/ISubMenu";
import { connect } from "react-redux";
import { UserRole } from "../../../constants/RoleEnum";

const AdminConfigurationSubMenu = (props: ISubMenu) => {
  const { currentRole } = props;
  const location = useLocation();

  const isActive = (path: string) => location.pathname.startsWith(path);

  return (
    <div className="admin-wrap">
      <div className="adminnav">
        {(currentRole === UserRole.SuperAdmin ||
          currentRole === UserRole.CollegeAdmin) && (
          <ul>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.BUTTON_INDEX}>
                Button
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.WIDGET_INDEX}>
                Widget
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.APP_INDEX}>Apps</NavLink>
            </li>
            {/* <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.STUDENT_RESOURCE_INDEX}>
                Student Resource
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.STUDENT_HELP_INDEX}>
                Student Help
              </NavLink>
            </li> */}
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.NOTIFICATION_INDEX}>
                Notifications
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.TECHNOLOGY_RESOURCE_INDEX}>
                Technology Resource
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.EMAIL_CONFIGURATION_INDEX}>
                Email Configuration
              </NavLink>
            </li>
            {/* <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.MEDIA_CONTENT_INDEX}>
                Media Content
              </NavLink>
            </li> */}
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.DESCRIPTION_INDEX}>
                Descriptions
              </NavLink>
            </li>
          </ul>
        )}
        {currentRole === UserRole.DepartmentAdmin && (
          <ul>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.NOTIFICATION_INDEX}>
                Notification
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.TRAINING_INDEX}>
                Training
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.REPORT_INDEX}>
                Report
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.DEPARTMENT_RESOURCE_INDEX}>
                Department Resource
              </NavLink>
            </li>
            <li>
              <NavLink to={CONFIGURATION_ROUTER_URL.TRAINING_HELP_INDEX}>
                Training Help
              </NavLink>
            </li>
          </ul>
        )}
      </div>
      <SubRouter />
    </div>
  );
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
  };
}

export default connect(mapStateToProps, null)(AdminConfigurationSubMenu);
